import { render, staticRenderFns } from "./proPage.vue?vue&type=template&id=51f7040c&scoped=true&"
import script from "./proPage.vue?vue&type=script&lang=js&"
export * from "./proPage.vue?vue&type=script&lang=js&"
import style0 from "./proPage.vue?vue&type=style&index=0&id=51f7040c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f7040c",
  null
  
)

export default component.exports